import { TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { useEffect, useRef } from 'react';
import { ReactComponent as InfoIcon } from '../../../assets/icons/information-fill.svg';
import { NbLoader } from '../loader/Loader';
import classes from './TextField.module.scss';

export type NbTextFieldProps = TextFieldProps & {
  size?: 'small' | 'default' | 'large';
  autoFocus?: boolean;
  errorMessage?: string;
  isLoading?: boolean;
  readOnly?: boolean;
};

export const NbTextField = ({
  className,
  size,
  autoFocus,
  errorMessage,
  isLoading,
  readOnly,
  disabled,
  ...props
}: NbTextFieldProps) => {
  const sizeClass = size === 'small' ? classes.nbTextFieldIsSmall : '';
  const inputRef = useRef<HTMLInputElement | null>(null);
  const loaderRef = useRef<HTMLDivElement | null>(null);

  const isDisabled = disabled || isLoading;

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef, autoFocus]);

  useEffect(() => {
    if (isLoading && inputRef.current && loaderRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      if (rect) {
        loaderRef.current.style.left = `${rect.width - 24}px`;
        loaderRef.current.style.display = `block`;
      }
    }
  }, [inputRef, isLoading]);

  return (
    <div className={classes.wrapper}>
      <TextField
        className={`${classes.nbTextField} ${className ?? ''} ${errorMessage ? classes.nbTextFieldHasError : ''}`}
        classes={{
          root: `${classes.nbTextField} ${sizeClass}`,
        }}
        inputRef={inputRef}
        helperText={errorMessage}
        InputProps={{
          readOnly,
          className: classes.orderFormRowQuantity,
          endAdornment: errorMessage ? (
            <span className={`${classes.nbTextFieldErrorIcon}`}>
              <InfoIcon />
            </span>
          ) : undefined,
        }}
        size={size}
        disabled={isDisabled}
        {...props}
      />
      {isLoading && (
        <NbLoader
          size="small"
          ref={loaderRef}
          className={classes.loader}
        />
      )}
    </div>
  );
};
